import React from 'react'
import styled from 'styled-components'
import LeftNav from './LeftNav'
import RightNav from './RightNav'

const Navbar = ({
  leftNavbarMinified,
  setLeftNavbarMinified,
  rightNavbarMinified,
  setRightNavbarMinified,
  rightNavbarVisible,
}) => {
  return (
    <Wrapper>
      <LeftNav
        leftNavbarMinified={leftNavbarMinified}
        setLeftNavbarMinified={setLeftNavbarMinified}
      />
      {rightNavbarVisible ? (
        <>
          <RightNav
            rightNavbarMinified={rightNavbarMinified}
            setRightNavbarMinified={setRightNavbarMinified}
          />
          <BlendDiv marginLeft={rightNavbarMinified ? '211px' : '370px'} />
        </>
      ) : (
        <></>
      )}
    </Wrapper>
  )
}
// '111px' : '271px'
// ? leftNavbarMinified
//   ? '191px'
//   : '291px'
// : leftNavbarMinified
// ? '351px'
// : '200px'

export default Navbar

const BlendDiv = styled.div`
  pointer-events: none;
  position: fixed;
  margin-left: ${({ marginLeft }) => marginLeft};
  width: 33px;
  height: 100vh;
  opacity: 0.25;
  mix-blend-mode: multiply;
  transition: margin 0.5s;
  background-image: linear-gradient(
    to right,
    #000 9%,
    rgba(255, 255, 255, 0) 74%
  );
`

// const Wrapper = styled.div`
//   position: fixed;
//   display: flex;
//   flex-direction: row;
// `

const Wrapper = styled.div`
  /* position: fixed; */
  display: flex;
  flex-direction: row;
  z-index: 1000;
  position: relative;
`
